import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useIsWorker } from "@/hooks/useIsWorker";
import { Briefcase } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

const WorkerRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading: authLoading } = useAuth();
  const { isWorker, loading: roleLoading } = useIsWorker();

  if (authLoading || roleLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-3">
          <Briefcase className="h-8 w-8 text-primary mx-auto animate-pulse" />
          <Skeleton className="h-4 w-32 mx-auto" />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!isWorker) return <Navigate to="/" replace />;

  return <>{children}</>;
};

export default WorkerRoute;
